import Home from 'containers/Home'

import MetaTags from 'components/MetaTags'
import Layout from 'components/Layout'

import { data } from 'constant/home'

import { masterDataService, defaultParams } from 'services'
import { SITE_URL } from 'lib/seo'

const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: '24 FIX',
      url: SITE_URL,
      logo: `${SITE_URL}/assets/images/24fix-black-logo.png`,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+66-2-028-2224',
        contactType: 'customer service',
        areaServed: 'TH',
        availableLanguage: ['Thai'],
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: '24 FIX',
      inLanguage: 'th-TH',
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
  ],
}

export default function Index({ canonical, banners, portfolios, promotions }) {
  const metadata = data?.metadata
  const metaTitle = metadata?.metaTitle
  const metaDescription = metadata?.metaDescription
  const metaImage = metadata?.shareImage?.url

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        image={metaImage}
        pathUrl={canonical}
        structuredData={organizationStructuredData}
      />

      <Layout>
        <Home data={data} banners={banners} portfolios={portfolios} promotions={promotions} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { res } = context

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  const getArticlesByType = code =>
    masterDataService({
      method: 'post',
      url: '/article/query',
      data: {
        where: [
          {
            ...defaultParams,
            articleTypes: {
              code: {
                $in: [code],
              },
            },
          },
        ],
      },
    }).then(response => response.data.data || [])

  const [banners, portfolios, promotions] = await Promise.all([
    getArticlesByType('banner'),
    getArticlesByType('portfolio'),
    getArticlesByType('promotion'),
  ])

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: SITE_URL,
        banners,
        portfolios,
        promotions,
      })
    ),
  }
}
